import { CSVData } from 'utils/csv-util'
import SearchableJob from 'jobs/SearchableJob'
import {
  exportValue,
  MutableColumnDetails,
  StaticColumnDetails,
} from './JobsTableColumns'

/**
 * Jobs Export Adapter.
 */
export function JobsExportAdapter(
  getAllFilteredJobs: () => Promise<SearchableJob[]>,
  getFilteredColumns: () => (StaticColumnDetails & MutableColumnDetails)[]
) {
  return {
    /**
     * Returns array containing jobs data organized for CSV exporting.
     */
    jobsExportData: async () => {
      const jobs = await getAllFilteredJobs()
      const columns = getFilteredColumns()
      const header: CSVData = [
        columns
          .filter((column) => column.visible)
          .map((column) => column.header)
          .concat('Job specs'),
      ]
      const data: CSVData = jobs.map((job) =>
        columns
          .filter((column) => column.visible)
          .map((column) => exportValue(column.id, job))
          .concat(job.jobSpecs.join(', '))
      )

      return header.concat(data)
    },
  }
}
